export const MANAGE_DEVICE_TYPE = {
    GET_ALL_MANAGE_DEVICE: 'GET_ALL_MANAGE_DEVICE',
    GET_ALL_MANAGE_DEVICE_SUCCESS: 'GET_ALL_MANAGE_DEVICE_SUCCESS',
    GET_ALL_MANAGE_DEVICE_FAILED: 'GET_ALL_MANAGE_DEVICE_FAILED',
    ADD_MANAGE_DEVICE: 'ADD_MANAGE_DEVICE',
    UPDATE_MANAGE_DEVICES: 'UPDATE_MANAGE_DEVICES',
    DELETE_MANAGE_DEVICE: 'DELETE__MANAGE_DEVICE'
}


const initState = {
    data: [],
    loading: false,
    error: false,
}

const manageDeviceReducer = (state = initState, action) => {
    switch (action.type){
        case MANAGE_DEVICE_TYPE.GET_ALL_MANAGE_DEVICE:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case MANAGE_DEVICE_TYPE.GET_ALL_MANAGE_DEVICE_SUCCESS: 
            return {
                data: action.data,
                loading: false,
                error: false,
            }
        case MANAGE_DEVICE_TYPE.GET_ALL_MANAGE_DEVICE_FAILED:
            return {
                loading: false,
                error: true,
            }
        case MANAGE_DEVICE_TYPE.ADD_MANAGE_DEVICE: 
            return {
                ...state,
                data: [...state.data, action.data]
            }
        case MANAGE_DEVICE_TYPE.UPDATE_MANAGE_DEVICES:
            let tempArr = [...state.data];
            tempArr = tempArr.map(item => {
                const manageDevice = action.data.find(md => md._id === item._id);
                if(manageDevice) {
                    return manageDevice;
                }

                return item;
            })
            return {
                ...state,
                data: tempArr
            }

        case MANAGE_DEVICE_TYPE.DELETE_MANAGE_DEVICE: 
            let tempArr1 = state.data.filter(item => action.data._id !== item._id);

            return {
                ...state,
                data: tempArr1
            }

        default:
            return state;
    }
}

export default manageDeviceReducer;